const UaFlagRouter = {
  path: '/ua-flag',
  name: 'UaFlag',
  redirect: '/ua-flag/home',
  component: () => import('@/layout/index'),
  children: [
    {
      path: 'home',
      name: 'UaFlagHome',
      component: () => import('@/views/ua-flag/home'),
      meta: { title: '赛事主页' }
    },
    {
      path: 'team-player',
      name: 'UaFlagTeamPlayer',
      component: () => import('@/views/ua-flag/team-player'),
      meta: { title: '参赛名单' }
    },
    {
      path: 'event-detail',
      name: 'UaFlagEventDetail',
      component: () => import('@/views/ua-flag/event-detail'),
      meta: { title: '比赛详情' }
    },
    {
      path: 'match/:matchId',
      name: 'UaFlagMatch',
      component: () => import('@/views/ua-flag/match'),
      redirect(to) {
        return { name: 'UaFlagStandings', params: { matchId: to.params.matchId } }
      },
      children: [
        {
          path: 'standings',
          name: 'UaFlagStandings',
          component: () => import('@/views/ua-flag/standings'),
          meta: { title: '积分榜' }
        },
        {
          path: 'schedule',
          name: 'UaFlagSchedule',
          component: () => import('@/views/ua-flag/schedule'),
          meta: { title: '赛程榜' }
        },
        {
          path: 'player-list',
          name: 'UaFlagPlayerList',
          component: () => import('@/views/ua-flag/player-list'),
          meta: { title: '球员榜' }
        },
        {
          path: 'team-data',
          name: 'UaFlagTeamData',
          component: () => import('@/views/ua-flag/team-data'),
          meta: { title: '球队数据' }
        }
      ]
    }
  ]
}
export default UaFlagRouter
